module.exports = __webpack_public_path__ + "img/MTABAPPPHOTO.e2a958c4.svg";